<svg [class.me-2]="position === 'left'" [class.ms-2]="position === 'right'"
     xmlns='http://www.w3.org/2000/svg'
     width='23' height='24' viewBox='0 1 23 24' fill='none'>
  <path
    d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'
    stroke='currentColor' stroke-width='1.5' stroke-miterlimit='10' />
  <path d='M8.25 12H15.75' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
  <path d='M12 8.25V15.75' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
</svg>